<template>
    <div class="ms">
        <!-- header -->
        <navbar-header></navbar-header>

        <!-- 背景层 -->
        <div class="bg_box"></div>

        <!-- titlebar -->
        <!-- <title-bar name="会议详情"></title-bar> -->

        <!-- mettingbox -->
        <activity-detail-box></activity-detail-box>

        <!-- footer -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
    import NavbarHeader from '@/components/index/NavbarHeader'
    import NavFooter from '@/components/common/NavFooter'
    import TitleBar from '@/components/common/TitleBar'
    import ActivityDetailBox from '@/components/zzsh/ActivityDetailBox'
    export default {
        components: {
            NavbarHeader,
            NavFooter,
            TitleBar,
            ActivityDetailBox,
        },
    }
</script>

<style lang="scss" scoped>
.ms {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 300px;
        z-index: -1;
    }
}
</style>